import { deleteToken } from '@firebase/messaging'
import * as Sentry from '@sentry/vue'
import { getMessaging } from 'firebase/messaging'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import environment from './environment'
import { EventBus, Topics, Types } from './event-bus'
import { roles } from './utils/auth'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersistence({
  key: environment.STORAGE_KEY, // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: (s) => ({
    auth: s.auth,
    general: s.general,
    locais: s.locais,
    etaMedicao: s.etaMedicao,
    epanetStyle: s.epanetStyle,
  }),
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  state: {
    ip: '',
    auth: {
      isAuthenticated: false,
      userToken: {
        expiration: null,
        refreshToken: null,
        token: null,
      },
      user: {
        id: null,
        userName: null,
        email: null,
        roles: [roles.ADMIN],
        userLocais: [],
      },
    },
    general: {
      notificationAsked: false,
    },
    style: {
      paddingPage: true,
      toolbar: true,
    },
    locais: {},
    etaMedicao: {},
    epanetStyle: 'mapbox://styles/mapbox/streets-v12',
  },
  mutations: {
    setEpanetStyle(state, style) {
      state.epanetStyle = style
    },
    setEtaMedicaoTemp(state, { etaId, value }) {
      state.etaMedicao[etaId] = value
    },
    togglePaddingPage(state) {
      state.style.paddingPage = !state.style.paddingPage
    },
    login(state, { userToken, user }) {
      state.auth.userToken = userToken

      state.auth.user = user

      state.auth.isAuthenticated = true

      Sentry.setUser({
        email: user.email,
        id: user.id,
        username: user.userName,
        ip_address: '{{auto}}',
      })
    },
    logout(state) {
      state.auth = {
        isAuthenticated: false,
        userToken: {
          expiration: null,
          refreshToken: null,
          token: null,
        },
        user: {
          id: null,
          userName: null,
          email: null,
          roles: [roles.ADMIN],
          userLocais: [],
        },
      }

      state.locais = {}
      state.etaMedicao = {}
    },
    setToolbarView(state, show) {
      state.style.toolbar = show
    },
    setIp(state, ip) {
      state.ip = ip
    },
    setNotificationAsked(state, asked) {
      state.general.notificationAsked = asked
    },
    setLocais(state, locais) {
      state.locais = locais
    },
  },
  actions: {
    login(context, data) {
      context.commit('login', data)

      EventBus.$emit(Topics.NOTIFICATIONS, {
        type: Types.INFO,
        message: 'Login Realizado com sucesso',
      })
    },
    logout(context, data) {
      context.commit('logout', data)

      Sentry.setUser(null)

      deleteToken(getMessaging()).catch((e) => {
        console.error('Error deleting token:', e)
      })
    },
    setToolbarView(context, boolean) {
      context.commit('setToolbarView', boolean)
    },
  },
  plugins: [vuexLocalStorage.plugin],
})
